import { applyTemplate } from './helpers';
import { RewriteRule } from './types';

export const transform = (
    inputUrl: string,
    rule: RewriteRule,
    options?: { maxInputLength?: number }
): string | null => {
    const maxInputLength = options?.maxInputLength ?? 4_096;
    if (inputUrl.length > maxInputLength) return null;

    const match = new RegExp(rule.regex).exec(inputUrl);
    if (!match) return null;

    // match[0] is the full match; capturing groups start at match[1]
    const vars: Record<string, string> = {};
    for (let i = 0; i < rule.groups.length; i++) {
        vars[rule.groups[i]] = match[i + 1] ?? '';
    }

    return applyTemplate(rule.template, vars);
};
